'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lsamples_Validation$package$$anon$7(evaluator$9) {
  this.Mj = null;
  this.Mj = evaluator$9;
}
export { $c_Lsamples_Validation$package$$anon$7 as $c_Lsamples_Validation$package$$anon$7 };
$p = $c_Lsamples_Validation$package$$anon$7.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lsamples_Validation$package$$anon$7;
/** @constructor */
function $h_Lsamples_Validation$package$$anon$7() {
}
export { $h_Lsamples_Validation$package$$anon$7 as $h_Lsamples_Validation$package$$anon$7 };
$h_Lsamples_Validation$package$$anon$7.prototype = $p;
$p.b = (function() {
  return "<function0>";
});
$p.v = (function() {
  var v = this.Mj.h();
  return ((v instanceof $j_java$002elang$002e$002dObject.$c_s_Option) ? new $j_java$002elang$002e$002dObject.$c_s_Some(v) : $j_java$002elang$002e$002dObject.$m_s_None$());
});
$p.h = (function() {
  return this.v();
});
var $d_Lsamples_Validation$package$$anon$7 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lsamples_Validation$package$$anon$7, "samples.Validation$package$$anon$7", ({
  rc: 1,
  d: 1,
  a: 1,
  f: 1
}));
export { $d_Lsamples_Validation$package$$anon$7 as $d_Lsamples_Validation$package$$anon$7 };
